<mat-drawer-container [ngClass]="{ 'drawer-container': true, open: opened }" hasBackdrop>
  <!-- setting keydown to undefined is a workaround.
  The escape key somehow does not close drawer when it is in a component that is using ChangeDetectionStrategy.OnPush.
  Setting keydown to undefined seems to solve this problem. -->
  <mat-drawer
    #drawer
    mode="over"
    [position]="position"
    class="drawer"
    (opened)="open()"
    (closed)="close()"
    (keydown)="(undefined) //noinspection BadExpressionStatementJS"
    [opened]="opened"
  >
    <!-- the material drawer component should handle to focus trap itself.
     However, it does not seem to work when position is set to end.
     As a workaround the focus trap is set manually in this case. -->
    <div class="drawer-content" [cdkTrapFocus]="position === 'end'">
      <ng-content />
      <button mat-icon-button [attr.aria-label]="'shared.close' | translate" class="drawer-close-button" (click)="drawer.close()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </mat-drawer>
</mat-drawer-container>
